import ApiGradient, { GradientType, GRADIENT_TYPES, Point } from "../api/model/snapshots/layers/Gradient";
import ColorStop from "./colorStop";
import Model from "./model";

export default class Gradient extends Model {
    #type: GradientType;
    from: Point;
    to: Point;
    colorStops: ColorStop[];
    angle: number | undefined;
    scale: number | undefined;
    aspectRatio: number | undefined;

    constructor({
        type,
        from,
        to,
        colorStops,
        angle,
        scale,
        aspectRatio
    }: ApiGradient) {
        super();

        this.#type = type;
        this.from = from;
        this.to = to;
        this.colorStops = colorStops.map(colorStop => new ColorStop(colorStop));
        this.angle = angle;
        this.scale = scale;
        this.aspectRatio = aspectRatio;
    }

    get type(): GradientType {
        return this.#type;
    }

    set type(type: GradientType) {
        if (!GRADIENT_TYPES.includes(type)) {
            throw new TypeError(`Unknown gradient type: '${type}'. Possible values: ${JSON.stringify(GRADIENT_TYPES)}`);
        }

        this.#type = type;
    }

    override toObject(): ApiGradient {
        const obj: ApiGradient = {
            type: this.type,
            from: this.from,
            to: this.to,
            scale: this.scale,
            colorStops: this.colorStops.map(colorStop => colorStop.toObject()),
            aspectRatio: this.aspectRatio
        };

        if (typeof this.angle !== "undefined") {
            obj.angle = this.angle;
        }

        return obj;
    }
}
